import { pxToEm } from '@insticator/insticator-ui';

/* ++++++++++ --------------- USERS PAGE : STYLES --------------- ++++++++++ */
export default {
  users: {
    // TODO: Move this to the global style
    '& label': {
      fontWeight: 700,
      marginBottom: pxToEm(16)
    },
    '& .field': {
      '& .label': {
        fontWeight: 700,
        marginBottom: pxToEm(16)
      },
      '&.type-checkbox, &.type-radio': {
        '& .label': {
          fontWeight: 400,
          marginBottom: 0
        }
      }
    }
  }
}; 